import { render, staticRenderFns } from "./CChoice.vue?vue&type=template&id=56c33e7e&"
import script from "./CChoice.vue?vue&type=script&lang=js&"
export * from "./CChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports